import React, { Fragment, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ServiceDetails from "./ServiceDetails";
import { useLanguage } from "../../context/LanguageContext";

const SeviceSinglePage: React.FC = () => {
  const { slug } = useParams<{ slug?: string }>();
  const { t, language } = useLanguage();

  const currentService =
    t.services.items.find((s) => s.slug === slug) || t.services.items[0];

  useEffect(() => {
    document.title = `${currentService.title} | ${t.company.name}`;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentService, language, t.company.name]);

  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle
              pageTitle={currentService.title}
              pagesub={t.nav.services}
            />
            <ServiceDetails currentService={currentService} />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default SeviceSinglePage;
